import React from "react";

import { Box, SxProps, Theme } from "@mui/material";

export const ImagePreview = ({
  imageUrl,
  height,
  width,
  sx = {},
}: {
  imageUrl: string;
  height: string;
  width: string;
  sx?: SxProps<Theme> | undefined;
}) => {
  return (
    <Box
      sx={{
        backgroundImage: `url("${imageUrl}")`,
        backgroundPosition: "center center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        height,
        width,
        borderRadius: 2,
        ...sx,
      }}
    />
  );
};
